<template>
  <v-app style="background-color: #F5F5F5;">
    <!-- <Navbar />
    <v-content class="grey lighten-4 mx-4 mt-4">
      <router-view></router-view>
    </v-content> -->
    <router-view></router-view>
    <!-- <component v-bind:is="layout"></component> -->
  </v-app>
</template>

<script>

// import Navbar from '@/components/Navbar'
// import AuthLayout from '@/layouts/AuthLayout'
// import AdminLayout from '@/layouts/AdminLayout'
import ENV from "./store/modules/environtment";
export default {
  name: 'App',
  // computed: {
  //   layout () {
  //     return this.$store.getters.layout
  //   }
  // },
  // components: {
  //   // Navbar
  //   'auth-layout': AuthLayout,
  //   'admin-layout': AdminLayout,
  // },
  data: () => ({
    env: ENV.EnvUsed
  }),
  mounted () {
    if(this.env === 'prod') {
      document.querySelector('script[name="gtm-config"]').innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PGVT7SM');
      `;
      document.querySelector('script[name="gtag-url"]').setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=G-CBWFE5WCYN");
      document.querySelector('script[name="gtag-config"]').innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
  
        gtag('config', 'G-CBWFE5WCYN');
      `;
      document.querySelector('noscript[name="gtm-iframe"]').innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PGVT7SM" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
    } else if(this.env === 'staging') {
      document.querySelector('script[name="gtm-config"]').innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-K5RHGGB');
      `;
      document.querySelector('script[name="gtag-url"]').setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=G-NTQ2DZRDS0");
      document.querySelector('script[name="gtag-config"]').innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
  
        gtag('config', 'G-NTQ2DZRDS0');
      `;
      document.querySelector('noscript[name="gtm-iframe"]').innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-K5RHGGB" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
    }
  }
};
</script>
<style>
#app {
  font-family: 'Noto Sans'; /* this was it */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
